import React, { Component } from "react";
import Seia from "./Seia";
import Bienes from "./Bienes";
import PoderJudicial from "./PoderJudicial";
import Sii from "./Sii";
import BackgroundProcess from "./BackgroundProcess";
import { SCRAPING_PAGE_TYPE } from "./../utils";
import Modal from "./Modal";
import { URLS, httpRequest } from "./../network";

import './../css/master.css';
import BoletinMineria from "./BoletinMinera";
import SoyChile from "./SoyChile";

class Master extends Component {

    NOTIFICATION_INTERVAL_TIME = 60000;

    constructor()  {
        super();
        this.state = {
            currentView: SCRAPING_PAGE_TYPE.Seia,
            modalMessage: "",
            showModalMessage: false,
            backgrounProcess: 0
        }
    }

    updateBackgrounState = (backgroundcount) => {
        this.setState({backgrounProcess: backgroundcount});
    }
    
    componentDidMount() {

        this.checkBackgroundProcessEnds();
        this.timerID = setInterval(() => this.checkBackgroundProcessEnds(), this.NOTIFICATION_INTERVAL_TIME);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    checkBackgroundProcessEnds = () => {
        httpRequest(URLS.GET_BACKGROUND_PROCESS, null, "GET")
            .then ((response) => {
                
                if (!response.success) {
                    console.log ("Error obteniendo procesos terminados!");
                    return;
                }

                this.setState({backgrounProcess:response.data.length });
                
            })
            .catch ((err) => {
                console.log("BackgroundProcess: err: " + JSON.stringify(err));
            });
    }

    messageError = (message) => {
        this.setState({showModalMessage: true, modalMessage: message} );
    }

    closeModalMessage = (e) =>  {
        this.setState({showModalMessage: false, modalMessage: "" });
    }

    renderSelection = () => {
        
        switch(this.state.currentView) {
            case SCRAPING_PAGE_TYPE.Seia:
                return <Seia errorMessage={this.messageError}/>;
            case SCRAPING_PAGE_TYPE.Bienes:
                return <Bienes errorMessage={this.messageError}/>;
            case SCRAPING_PAGE_TYPE.PJUD:
                return <PoderJudicial errorMessage={this.messageError}/>;
            case SCRAPING_PAGE_TYPE.SII: 
                return <Sii errorMessage={this.messageError}/>;
            case SCRAPING_PAGE_TYPE.BoletinMineria:
                return <BoletinMineria errorMessage={this.messageError} />;
            case SCRAPING_PAGE_TYPE.BackgroundProcess:
                return <BackgroundProcess errorMessage={this.messageError} updateBackgroundCount={this.updateBackgrounState} />;
            case SCRAPING_PAGE_TYPE.SoyChile:
                return <SoyChile errorMessage={this.messageError} />
            default:
                console.log ("NO se encontro ninguna vista pre definida")
                return null;
        }
     
    }

    elementClickStyle = (view) => {

        if (this.state.currentView === view) {
            return "menu-item selected-item";
        }

        return "menu-item";
    }

    render () {
        return (
            <div id="wrapper">
                <div id="header">
                    <img className="company-logo" src={require("./../imgs/visiongis_logo.png")} alt="logo" />
                    <label>VisionGIS Scraping</label>
                </div>
                <div id="nav" >
                    <u className="menu">
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.Seia)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.Seia})}}>
                            <label>SEIA</label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.Bienes)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.Bienes})}} >
                            <label>Bienes Nacionales</label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.PJUD)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.PJUD})}} >
                            <label>Poder Judicial</label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.SII)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.SII})}} >
                            <label>SII </label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.BoletinMineria)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.BoletinMineria})}} >
                            <label>Diario Oficial </label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.SoyChile)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.SoyChile})}} >
                            <label>Soy Chile </label>
                        </li>
                        <li className={this.elementClickStyle(SCRAPING_PAGE_TYPE.BackgroundProcess)} onClick={ () => { this.setState( {currentView: SCRAPING_PAGE_TYPE.BackgroundProcess})}} >
                            <label>Trabajos en Background 
                                {
                                    this.state.backgrounProcess > 0 && <div className="badge"><span>{this.state.backgrounProcess}</span></div> 
                                }
                                </label>
                        </li>
                    </u>
                </div>
                <div id="content">
                    {this.renderSelection()}

                    {
                        this.state.showModalMessage &&
                            <Modal  title="Alerta" open={this.state.showModalMessage} 
                                onCloseModal={this.closeModalMessage} >
                                <div className="modal-message">
                                    <div>{this.state.modalMessage}</div>
                                    <button className="btn btn-primary" onClick={this.closeModalMessage}> Aceptar </button>
                                </div>
                            </Modal>
                    }
                    
                </div>
                
            </div>
        );
    }
}

export default Master;